var staticStrUndefined = 'undefined'

module.exports = staticStrUndefined



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticStrUndefined.js
// module id = 15
// module chunks = 98